import { SvgIcon } from '@mui/material';
import { OpenGovLogo } from '@opengov/react-capital-assets';
import React from 'react';

import { DATA_TEST } from '../../enums';

export const OpenGovSVGIcon = () => {
  return (
    <SvgIcon
      sx={{
        margin: '0 !important',
        width: '120px',
        height: '45px'
      }}
      data-test={DATA_TEST.nav_icon_opengov}
      aria-label="OpenGov Logo"
      inheritViewBox={true}
      component={OpenGovLogo}
    />
  );
};
